module.exports = __webpack_public_path__ + "img/badge-2.a8b3b5f6.png";